import { useEffect, useRef, useState } from "react";
import { Button, Spinner } from "react-bootstrap";

function BinderCardViewer({
  name,
  frontImage,
  backImage,
  side,
  onRotate,
  isZoomed,
  zoomOrigin,
  onMoveZoom,
  onResetZoom,
  onToggleZoom,
  className = "binder-feature-image",
  imageClassName = "",
  isMissing = false
}) {
  const touchStartX = useRef(null);
  const [frontLoaded, setFrontLoaded] = useState(false);
  const [backLoaded, setBackLoaded] = useState(false);

  const [frontError, setFrontError] = useState(false);
  const [backError, setBackError] = useState(false);
  useEffect(() => { setFrontLoaded(false); setFrontError(false); }, [frontImage]);
  useEffect(() => { setBackLoaded(false); setBackError(false); }, [backImage]);

  const activeImageLoaded = side === "back" && backImage ? backLoaded || backError : frontLoaded || frontError;
  const rotate = event => {
    event.stopPropagation();
    onRotate();
  };

  return (
    <div className={`${className}${isMissing ? " is-missing" : ""}`}>
      <Button
        variant="light"
        className="binder-preview-arrow left"
        size="sm"
        disabled={!backImage}
        onClick={rotate}
        aria-label="Ver lado anterior"
      >
        <i className="bi bi-chevron-left" />
      </Button>
      <div
        className={`binder-card-flip ${imageClassName} ${side === "back" ? "is-back" : ""} ${isZoomed ? "is-zoomed" : ""}`}
        onPointerMove={onMoveZoom}
        onMouseLeave={onResetZoom}
        onTouchStart={event => { touchStartX.current = event.touches[0]?.clientX ?? null; }}
        onTouchEnd={event => {
          const endX = event.changedTouches[0]?.clientX;
          if (touchStartX.current !== null && endX !== undefined && Math.abs(endX - touchStartX.current) > 45 && backImage) onRotate();
          touchStartX.current = null;
        }}
        onClick={onToggleZoom}
        onKeyDown={event => {
          if (event.key === "Enter" || event.key === " ") {
            event.preventDefault();
            onToggleZoom();
          }
        }}
        role="button"
        tabIndex={0}
        aria-label={`Ampliar ${name}`}
        style={{
          "--card-zoom-x": `${zoomOrigin.x}%`,
          "--card-zoom-y": `${zoomOrigin.y}%`
        }}
      >
        {!activeImageLoaded && (
          <div className="binder-card-image-loader" role="status" aria-label="Cargando imagen">
            <Spinner animation="border" size="sm" />
          </div>
        )}
        <div className={`binder-card-face binder-card-front${frontLoaded || frontError ? " is-loaded" : ""}`}>
          {frontError?<div className="binder-card-image-error"><i className="bi bi-image"/><span>No se pudo cargar el frente</span></div>:<img src={frontImage} alt={`${name} frente`} onLoad={() => setFrontLoaded(true)} onError={() => setFrontError(true)} />}
        </div>
        <div className={`binder-card-face binder-card-back${backLoaded || backError ? " is-loaded" : ""}`}>
          {backImage && !backError ? (
            <img src={backImage} alt={`${name} reverso`} onLoad={() => setBackLoaded(true)} onError={() => setBackError(true)} />
          ) : (
            <div className="binder-card-back-empty">
              <i className={backError?"bi bi-exclamation-circle":"bi bi-card-image"} />
              <span>{backError?"No se pudo cargar el reverso":"Reverso no subido"}</span>
            </div>
          )}
        </div>
      </div>
      <Button
        variant="light"
        className="binder-preview-arrow right"
        size="sm"
        disabled={!backImage}
        onClick={rotate}
        aria-label="Ver lado siguiente"
      >
        <i className="bi bi-chevron-right" />
      </Button>
    </div>
  );
}

export default BinderCardViewer;